export const french = {
    //languages
    english : "Anglais",
    french : "Français",
    arabic : "Arabe",
    //navbar
    loading : "Chargement",
    home : "Accueil",
    about : "A propos",
    services : "Services",
    projects : "Projets",
    contact_nav : "Contactez-moi",
    //banner
    text_banner1 : "Bienvenue au site Aymane Web-Dev\nOù les rêves numériques prennent vie",
    text_banner2 : "Libérez votre potentiel en ligne\nAvec un développeur web expert",
    text_banner3 : "Prêt à valoriser votre présence en ligne ?\nConstruisons quelque chose d'extraordinaire ensemble.",
    button_banner : "Choisir votre service",
    // modal
    service_title : "Service",
    service_select : "Veuillez choisir votre service",
    service_select_text : "Pourriez-vous s'il vous plaît d'entrer une adresse e-mail valide afin de pouvoir continuer vers la page suivante",
    service_plugin_maintenance : "Pouvez-vous s'il vous plaît fournir les détails de vos besoins ci-dessous ? Cela me permettra de vous envoyer un devis plus précis",
    service_textarea_placehoder : "Veuillez détailler vos besoins, s'il vous plaît",
    send : "Envoyé devis",
    close : "Fermer",
    next_text : "Pour passer à la page suivante, veuillez sélectionner un service et insérer une adresse e-mail valide.",
    //conatct form
    service_contact_first_name : "Prénom",
    service_contact_last_name : "Nom",
    service_contact_phone : "N° téléphone",
    service_contact_email : "Adresse email",
    service_contact_first_name_placeholder : "Votre prénom",
    service_contact_last_name_placeholder : "Votre nom",
    service_contact_phone_placeholder : "Votre numéro de téléphone",
    service_contact_email_placeholder : "Votre adresse email",
    optionnal : "Optionnel",
    not_optionnal : "Obligatoire",
    //services
    ecommerce_service : "Service Ecommerce",
    ecommerce_select : "Veuillez choisir votre service e-commerce",
    ecommerce_delivery : "Paiement à la livraison uniquement",
    ecommerce_delivery_crediCard : "Paiement par carte de crédit et paiement à la livraison",
    page_add_title : "Ajouter des pages",
    multiling_page : "Page multilingue",
    multiling_website : "Siteweb multilingue",
    lang_website : "Langue",
    lang_websites : "Langues",
    functionlities_add : "Ajouter des fonctionnalités",
    functionlities_select : "Veuillez choisir une fonctionnalité",
    dollar : "USD",
    responsive_service : "Conception responsive",
    newsLetter_service : "Inscription à la newsletter",
    seo_service : "Optimisation SEO",
    admin_service : "Page d'administration (Page de tableau de bord, ajouter, mettre à jour, supprimer des éléments)",
    other_service : "Commentaire",
    other_discuss : "Écrire un commentaire ou ajouter d'autres fonctionnalités",
    error : "Une erreur s'est produite",
    error_language : "Tous Les champs de langues sont obligatoire",
    //service price
    initial_price : "Prix initial",
    initial_price_text : "Le prix initial inclut la page d'accueil, la page À propos de nous, le formulaire de contact",
    initial_price_text_application : "ainsi que toutes les fonctionnalités de l'application web",
    initial_price_text_blog1 : "Le prix initial inclut la page d'accueil, la page À propos de nous, la page de blog, le formulaire de contact, la page d'administration,",
    initial_price_text_blog2 : "ainsi que toutes les fonctionnalités du site de blog",
    initial_price_text_ecommerce1 : "Le prix initial comprend la page d'accueil, la page À propos de nous, la conception responsive, le formulaire de contact,",
    initial_price_text_ecommerce2 : "le système de connexion utilisateur, la page de paiement, la page d'administration,, ainsi que toutes les fonctionnalités du site de commerce électronique",
    initial_price_text_educational1 : "Le prix initial comprend la page d'accueil, la page À propos de nous, le formulaire de contact, le système de connexion utilisateur,",
    initial_price_text_educational2 : "l'implémentation de paiement, la page d'administration, et l'ensemble des fonctionnalités du site éducatif",
    total_price : "Prix total",
    total_price_text : "Les taxes ne sont pas inclus dans le prix total",
    total_price_other : "Le prix des autres services sera ajouté et vous sera envoyé ultérieurement",
    page_add_numbers_title : "Pages supplémentaires",
    page : "page",
    pages : "pages",
    functionalities : "Fonctionnalités",
    //about page
    about_header : "A PROPOS",
    about_text : "Bonjour, je suis Aymane Chnaif, et je suis passionné par la concrétisation d'idées numériques. Avec une concentration dévouée sur la création de sites web impressionnants et d'applications mobiles dynamiques, j'ai trois années d'expérience avérée dans le monde du développement web full-stack et de la conception d'applications mobiles.",
    about_text2 : "Avec une attention dédiée à la création de sites web impressionnants et d'applications mobiles dynamiques, j'ai trois ans d'expérience dans le développement web complet et la conception d'applications mobiles.",
    about_text3 : "Je suis enthousiaste à l'idée d'entendre parler de vos idées de projet et de discuter de la façon dont je peux vous aider à atteindre vos objectifs. Que ce soit pour une refonte de site web, une nouvelle application mobile, ou tout autre projet, collaborons ensemble pour donner vie à votre vision.",
    skills : "Mes compétences clés",
    skill_fullStack : "Développement Web Full-Stack",
    skill_fullStack_text1 : "Je me spécialise dans la création de solutions web de bout en bout, de la conception à la mise en œuvre et au déploiement.",
    skill_fullStack_text2 : "Mon expertise couvre à la fois les technologies front-end et back-end, me permettant de créer des expériences fluides et conviviales pour les utilisateurs.",
    skill_mobile : "Développement d'applications mobiles",
    skill_mobile_text : "En plus du développement web, je suis compétent dans la création d'applications mobiles pour les plateformes iOS et Android. Qu'il s'agisse d'une application native ou multiplateforme, j'ai les compétences nécessaires pour concrétiser votre idée d'application mobile.",
    skill_responsive : "Conception responsive",
    skill_responsive_text : "Garantir que les sites web et les applications aient un aspect attrayant et fonctionnent parfaitement sur tous les appareils est une priorité absolue. J'utilise les principes de conception adaptative pour garantir une expérience fluide sur les smartphones, les tablettes et les ordinateurs de bureau.",
    skill_backEnd : "Développement Back-end",
    skill_backEnd_text : "J'ai de l'expérience avec les technologies côté serveur, les bases de données et les API. Je construis des backends robustes et évolutifs pour soutenir la fonctionnalité des applications web et mobiles.",
    skill_ProblemSolving : "Résolution de problèmes",
    skill_ProblemSolving_text : "Mon état d'esprit analytique et mes compétences en résolution de problèmes me permettent de relever efficacement des défis complexes et de proposer des solutions innovantes.",
    // work with me section
    wokr_with_me : "POURQUOI TRAVAILLER AVEC MOI",
    quality_header : "Qualité et Précision",
    quality_text : "Je suis fier de fournir un travail de haute qualité avec une attention méticuleuse aux détails. Votre projet sera soigné",
    collaborative_header : "Approche collaborative",
    collaborative_text : "Je crois en la communication ouverte et la collaboration. Vos suggestions et commentaires sont essentiels à la réussite du projet.",
    onTime_header : "Livraison dans les délais",
    onTime_text : "Je comprends l'importance des délais. Je m'engage à livrer les projets à temps et dans le respect du budget.",
    learning_header : "Apprentissage continu",
    learning_text : "La technologie évolue constamment. Je m'engage à suivre les dernières tendances pour vous proposer des solutions innovantes.",
    //service section
    my_services : "MES SERVICES",
    //project section
    project : "MES PROJETS",
    link_project : "Lien du projet",
    additionnal : "Des projets supplémentaires seront présentés sur le site web à l'avenir",
    //hire section
    hire : "PROJETS À LONG TERME",
    hire_text_1 : "Cette section s'adresse aux personnes intéressées par des projets à long terme ou à moyen terme. Je suis enthousiaste à l'idée d'entendre parler de vos idées de projet ",
    hire_text_2 : "et discuter de comment je peux vous aider à atteindre vos objectifs, n'hésitez pas à me contacter aux coordonnées ci-dessous.",
    forntEnd : "Technologies de développement Front-end et Design",
    backEnd : "Technologies de développement Back-end et Base de données",
    languages : "Langues parlées",
    languages_arab : "Arabe",
    languages_french : "Français",
    languages_english : "Anglais",
    languages_level : "Bonne connaissance",
    languages_native : "Langue maternelle",
    myName : "Aymane Chnaif",
    fullStack : "Ingénieur full stack",
    //contact section
    contact : "CONTACTEZ-MOI",
    fullName : "Nom complet",
    fullName_placeholder : "Votre nom complet",
    subject : "Sujet",
    message : "Message",
    file : "Cahier des charges",
    file_text : "Si vous avez déjà préparé le cahier des charges de votre site web, veuillez bien vouloir les partager avec moi. Je vous fournirai rapidement un devis",
    send_message : "Envoyer Message",
    //footer section
    phone : "Téléphone",
    useful_links : "Liens Utiles",
    terms : "Conditions d'utilisation",
    privacy : "Politique de confidentialité",
    landing : "Landing pages",
    web : "Applications web",
    mobile : "Applications mobiles",
    maintenance : "Maintenance de site web",
    plugin : "Extensions WordPress",
    copyright : "Droit d'auteur",
    rights : "Tous droits réservés",
}